import * as yup from "yup";
import { CantidadSchema } from "./CantidadSchema";

export const FuncionamientoSchema = yup.object().shape({
  horas: CantidadSchema.required("errors.funcionamiento.horas.required")
    .test("magnitud.min", "errors.cantidad.magnitud.min", (value, context) => {
      return value?.magnitud > 0;
    })
    .test(
      "magnitud.max",
      "errors.funcionamiento.horas.max",
      (value, context) => {
        return value?.magnitud <= 168;
      },
    )
    .default({ magnitud: 0, unidad: { codigo: "HSEM" } }),
  dias: CantidadSchema.required("errors.funcionamiento.dias.required")
    .test("magnitud.min", "errors.cantidad.magnitud.min", (value, context) => {
      return value?.magnitud > 0;
    })
    .test(
      "magnitud.max",
      "errors.funcionamiento.dias.max",
      (value, context) => {
        return value?.magnitud <= 7;
      },
    )
    .default({ magnitud: 0, unidad: { codigo: "DSEM" } }),
  meses: CantidadSchema.required("errors.funcionamiento.meses.required")
    .test("magnitud.min", "errors.cantidad.magnitud.min", (value, context) => {
      return value?.magnitud > 0;
    })
    .test(
      "magnitud.max",
      "errors.funcionamiento.meses.max",
      (value, context) => {
        return value?.magnitud <= 12;
      },
    )
    .default({ magnitud: 0, unidad: { codigo: "MESANIO" } }),
});
